// import denormalizer from './denormalizer'
// import normalizer from './normalizer'
import Service, { getCallApiFunction } from '../service'
import { isUndefined } from 'lodash-es'

interface IParams {
  ssrLocale?: any
  params: any
}

class FetchCategoryFilterApi extends Service {
  constructor({ ssrLocale, params }: IParams) {
    super()
    this.name = 'FETCH_CATEGORY_FILTER'

    const basicConfig = {
      url: `/v1/product/category/root`,
      method: 'GET',
      params: { ...params },
    }
    const localeConfig = {
      'Tutor-Header-Locale': ssrLocale,
    }
    const config = isUndefined(ssrLocale) ? basicConfig : { ...basicConfig, headers: localeConfig }

    this.config = config
  }
}

export const fetchCategoryFilter = (params: any) => getCallApiFunction(new FetchCategoryFilterApi(params))
